import React, { useEffect, useState } from "react";
import api from "../../api/config";
import Ratings from "../../assets/images/Ratings.png";
import Search from "../../assets/images/Search.png";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import "../../styles/spacefeedseacrh.css";
import { toast } from "react-toastify";
import SearchAccordion from "./SearchAccordion";
import { useNavigate } from "react-router-dom";
import CreateAsyncPaginateDropdown from "../common/CreateableAsyncPaginate";
import { ReactComponent as SearchIcon } from "../../assets/icons9-search.svg";
import LocationFetcher from "./FetchCurrentLocation";

const onAction = (node, action) => {
  //console.log"onAction::", action, node);
};

let getAuth = localStorage.getItem("data");
getAuth = JSON.parse(getAuth);
//console.loggetAuth, "getAuth");


const SpaceFeedSearch = ({
  categoryList,
  searchLoading,
  setSearchLoading,
  setCategoryList,
  setSearchPayload,
  searchPayload,
  handleTagClick,
}) => {
  const [location, setLocation] = useState(null);
  const [searchTrendingList, setSearchTrendingList] = useState([]);
  const [mySearchList, setMySearchList] = useState([]);
  const [loadingPropertyType, setLoadingPropertyType] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [value, onChange] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState({});

  const navigate = useNavigate();

  let auth = localStorage?.getItem("data");
  auth = JSON?.parse(auth);
  let role = localStorage?.getItem("role");
  const onNodeToggle = (currentNode) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [currentNode.value]: !prev[currentNode.value], // Toggle expanded/collapsed state
    }));
  };
  useEffect(() => {
    const fetchMySearch = async () => {
      try {
        const response = await api.get("/user-search-history");
        if (response?.data?.status === 200) {
          //console.log"my searches from api>>>>" + response?.data?.response);
          setMySearchList(response?.data?.response);
        }
      } catch (error) {
        //console.logerror, "Something went wrong");
      }
    };

    if (auth) {
      fetchMySearch();
    } else {
      // If not authenticated, load stored categories from localStorage
      const storedCategories = localStorage.getItem("selectedCategories");
      const storedSubCategories = localStorage.getItem("selectedSubCategories");
      if (storedCategories && storedSubCategories) {
        setSelectedCategories(JSON.parse(storedCategories));
        setSelectedSubCategories(JSON.parse(storedSubCategories));
      }
    }
  }, []);

  useEffect(() => {
    const fetchTrendSearch = async () => {
      try {
        const response = await api.get("/search-trending");
        if (response?.data?.status === 200) {
          setSearchTrendingList(response?.data?.response);
        }
      } catch (error) {
        //console.logerror, "Something went wrong");
      }
    };

    fetchTrendSearch();
  }, []);

  useEffect(() => {
    if (!auth) {
      const storedData = localStorage.getItem("categorySubCategoryList");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        //console.log"my searches from cache>>>>>" + parsedData);
        setMySearchList(parsedData);
      }
    }
  }, []);

  const fetchCategories = async () => {
    setLoadingPropertyType(true);
    try {
      const propertyCategory = await api.get("/property-category");
      setCategoryList(propertyCategory.data.response);
    } catch (error) {
      toast.error("Error fetching categories");
      //console.logerror);
    } finally {
      setLoadingPropertyType(false);
    }
  };

  const onChangeCat = (currentNode, selectedNodes) => {
    if (currentNode._depth === 0) {
      const categoryId = currentNode.value.replace("cat_", "");

      if (currentNode.checked) {
        setSelectedCategories((prevSelectedCategories) => [
          ...prevSelectedCategories,
          categoryId,
        ]);
        // Add subcategory IDs of the matched category from setCategoryList
        const matchedCategory = categoryList.find(
          (category) =>
            category.categoryId == currentNode.value.replace("cat_", "")
        );
        if (matchedCategory) {
          const matchedSubCategoryIds =
            matchedCategory.propertySubCategories.map(
              (subcategory) => subcategory.subCategoryId
            );
          // Push the matched subcategory IDs into selectedSubCategories
          setSelectedSubCategories((prevSubCategories) => {
            return [
              ...new Set([...prevSubCategories, ...matchedSubCategoryIds]),
            ];
          });
        }
      } else {
        setSelectedCategories((prevSelectedCategories) =>
          prevSelectedCategories.filter((id) => id !== categoryId)
        );
        setSelectedSubCategories((prevSubCategories) =>
          prevSubCategories.filter(
            (subCategoryId) =>
              !categoryList
                .find((category) => category.categoryId == categoryId)
                ?.propertySubCategories.some(
                  (subcategory) => subcategory.subCategoryId === subCategoryId
                )
          )
        );
      }
    } else if (currentNode._depth === 1) {
      // Handle subcategory selection
      const subCategoryId = currentNode.value.replace("subcat_", "");

      // Find the category ID based on the selected subcategory ID
      const categoryId = categoryList.find((category) =>
        category.propertySubCategories.some(
          (subcategory) => subcategory.subCategoryId == subCategoryId
        )
      )?.categoryId;

      if (currentNode.checked) {
        // Add subcategory to selectedSubCategories
        setSelectedSubCategories((prevSubCategories) => [
          ...prevSubCategories,
          subCategoryId,
        ]);

        // Add category to selectedCategories if not already present
        if (!selectedCategories.includes(categoryId)) {
          setSelectedCategories((prevSelectedCategories) => [
            ...prevSelectedCategories,
            categoryId,
          ]);
        }
      } else {
        // Remove subcategory from selectedSubCategories
        setSelectedSubCategories((prevSubCategories) =>
          prevSubCategories.filter((id) => id != subCategoryId)
        );

        // Check if all subcategories of the parent category are unchecked, if so, remove the category from selectedCategories
        const category = categoryList.find(
          (category) => category.categoryId == categoryId
        );
        if (category) {
          const allSubCategoriesUnchecked =
            category.propertySubCategories.every(
              (subcategory) =>
                !selectedNodes.find(
                  (node) =>
                    node.value == `subcat_${subcategory.subCategoryId}` &&
                    node.checked
                )
            );
          if (allSubCategoriesUnchecked) {
            setSelectedCategories((prevSelectedCategories) =>
              prevSelectedCategories.filter((id) => id != categoryId)
            );
          }
        }
      }
    }
  };

  let selectedCat = [];

  useEffect(() => {
    const selectedSubCat = selectedSubCategories.map((subCatId) =>
      parseInt(subCatId)
    );
    categoryList.forEach((category) => {
      const subCategoryIds = category.propertySubCategories.map(
        (subCat) => subCat.subCategoryId
      );
      const hasSubCategories = subCategoryIds.length > 0;
      const allSubCategoriesIncluded = subCategoryIds.every((subCatId) =>
        selectedSubCat.includes(subCatId)
      );

      if (hasSubCategories && allSubCategoriesIncluded) {
        selectedCat.push(category.categoryId);
        // Remove the subcategories from selectedSubCat
        subCategoryIds.forEach((subCatId) => {
          const index = selectedSubCat.indexOf(subCatId);
          if (index !== -1) {
            selectedSubCat.splice(index, 1);
          }
        });
      }
    });

    setSearchPayload({
      ...searchPayload,
      category: selectedCat.map(Number),
      subCategory: selectedSubCat.map(Number),
    });
  }, [selectedCategories, selectedSubCategories]);

  useEffect(() => {
    // if (!!auth?.jwt) {
    fetchCategories();
    // }
  }, []);

  let categoryNameList =
    JSON.parse(localStorage.getItem("categoryNameList")) || [];
  let subCategoryNameList =
    JSON.parse(localStorage.getItem("subCategoryNameList")) || [];
    let locationNameList =
    JSON.parse(localStorage.getItem("locationNameList")) || [];

  const fetchCategorySubCategoryLocally = () => {
    if (!auth) {
      //console.logcategoryNameList, "categoryNameList---");
      //console.logsubCategoryNameList,"subCategoryNameList>>>" );
      //console.loglocationNameList,"locationNameList>>>" );
      categoryList.forEach((cat) => {
        // Check if categoryId already exists in categoryNameList
        const categoryExists = categoryNameList.some(
          (item) => item.categoryId === cat.categoryId
        );
        if (searchPayload?.category?.includes(cat.categoryId)) {
          if (!categoryExists) {
            categoryNameList.push({
              categoryId: cat.categoryId,
              category: cat.category,
            });
          }
          // Remove subcategories if the category is selected
          subCategoryNameList = subCategoryNameList.filter(
            (subCat) =>
              !cat.propertySubCategories.some(
                (c) => c.subCategoryId === subCat.subCategoryId
              )
          );
        } else {
          // If category is not selected, check and add its subcategories
          cat.propertySubCategories.forEach((subCat) => {
            const subCategoryExists = subCategoryNameList.some(
              (item) => item.subCategoryId === subCat.subCategoryId
            );
            if (
              searchPayload?.subCategory?.includes(subCat.subCategoryId) &&
              !subCategoryExists
            ) {
              subCategoryNameList.push({
                subCategoryId: subCat.subCategoryId,
                subCategory: subCat.subCategory,
              });
            }
          });
        }
      });
      if(value){
        if (!locationNameList?.includes(value.value)) {
          locationNameList.push(
            {location:value.value}
          );
        }
      }
      return { categoryNameList, subCategoryNameList,locationNameList };
    }
  };

  const handleSubmit = async () => {
    setSearchLoading(true);
    try {
      //console.logvalue,"-----location");
      if (
        !auth && ((
        selectedCategories.length > 0 &&
        selectedSubCategories.length > 0 ) || (value))
      ) {
        const res = fetchCategorySubCategoryLocally();
        //console.logres, "res1");

        // Combine both lists and save in localStorage
        const combinedList = [...categoryNameList, ...subCategoryNameList,...locationNameList];
        //console.logcombinedList, "combinedList");

        localStorage.setItem(
          "categoryNameList",
          JSON.stringify(categoryNameList)
        );
        localStorage.setItem(
          "subCategoryNameList",
          JSON.stringify(subCategoryNameList)
        );
        localStorage.setItem(
          "locationNameList",
          JSON.stringify(locationNameList)
        );
        localStorage.setItem(
          "categorySubCategoryList",
          JSON.stringify(combinedList)
        );
      }

      const response = await api.post("/search-space-feed", searchPayload);
      if (response?.data?.status === 200) {
        navigate("/property-search", {
          state: { searchData: response.data },
        });
      }
      // setSpaceFeedList() Will  be used to update the state of space feed list in parent component
    } catch (error) {
      toast.error("Something went wrong");
      //console.logerror, "error");
    } finally {
      setSearchLoading(false);
    }
  };

  const convertedData = categoryList.map((item) => ({
    label: item?.category,
    value: "cat_" + item?.categoryId,
    children: item?.propertySubCategories?.map((subCategory) => ({
      label: subCategory?.subCategory,
      value: "subcat_" + subCategory?.subCategoryId,
      checked: selectedSubCategories.some(
        (selectedId) =>
          parseInt(selectedId, 10) === parseInt(subCategory.subCategoryId, 10)
      ),
    })),
    checked: selectedCategories.some(
      (selectedId) => parseInt(selectedId, 10) === parseInt(item.categoryId, 10)
    ),
    expanded: !!expandedNodes["cat_" + item?.categoryId], // initially collapsed, adjust as needed
  }));

  return (
    <>
      <div className="search-section">
        <div className="subsection w-75 rounded">
          <div className="inner-section rounded">
            <span className="text-dark fw-bold px-1">
              What are you looking for?
            </span>
            <DropdownTreeSelect
              disabled={loadingPropertyType ? true : false}
              texts={{ placeholder: "Select Your Activity" }}
              data={convertedData}
              onChange={onChangeCat}
              onAction={onAction}
              onNodeToggle={onNodeToggle}
              keepTreeOnSearch={false} // check if this needs to be true
              showPartiallySelected={true} // helps in showing partially selected nodes
              className="custom-placeholder"
              keepOpenOnSelection={true}
            />
          </div>
          <div className="inner-section2 rounded">
            <span className="text-dark fw-bold">Where / Search Keyword</span>
            <CreateAsyncPaginateDropdown
              searchPayload={searchPayload}
              setSearchPayload={setSearchPayload}
              value={value}
              onChange={onChange}
            />
          </div>
          <div className="inner-section3">
            <button
              onClick={handleSubmit}
              type="button"
              disabled={searchLoading}
              className="search-btn rounded dark"
            >
              <span className="search-icon">
                <SearchIcon className="icon" />
              </span>
              <span className="search-text">
                {searchLoading ? "Processing" : "Search"}
              </span>
            </button>
            <LocationFetcher
              onChange={onChange}
              location={location}
              setLocation={setLocation}
            />
          </div>
        </div>
        {role !== "provider" && (
          <SearchAccordion
            icon={Search}
            handleTagClick={handleTagClick}
            index="One"
            style={{ marginRight: "10px" }}
            title="My Searches"
            accordionId="accordionExample"
            data={mySearchList}
          />
        )}  

        <SearchAccordion
          handleTagClick={handleTagClick}
          icon={Ratings}
          index="Three"
          style={{ marginRight: "10px" }}
          title="Trending Searches"
          accordionId="accordionExample1"
          data={searchTrendingList}
        />
      </div>
    </>
  );
};

export default SpaceFeedSearch;
